import { Stripe } from '@stripe/stripe-js'
import ActionMap from 'src/types/ActionMap'
import AppContextInitialState from 'src/types/AppContextInitialState'
import IUser from 'src/types/User'

export enum Types {
  Authenticate = 'AUTHENTICATE',
  SetUser = 'SET_USER',
  RestoreLogin = 'RESTORE_LOGIN',
  Logout = 'LOGOUT',
  Loading = 'LOADING',
  UpdateUser = 'UPDATE_USER',
  LoadStripe = 'LOAD_STRIPE',
}

type AppPayload = {
  [Types.Authenticate]: {
    isAuthenticated: boolean
    user: IUser
    token: string
  }
  [Types.SetUser]: { user: IUser }
  [Types.RestoreLogin]: {}
  [Types.Logout]: {}
  [Types.Loading]: { loading: boolean }
  [Types.UpdateUser]: {}
  [Types.LoadStripe]: { stripe: Stripe | null }
}

export type AppActions = ActionMap<AppPayload>[keyof ActionMap<AppPayload>]

export const appReducer = (state: AppContextInitialState, action: AppActions) => {
  switch (action.type) {
    case 'AUTHENTICATE':
      localStorage.setItem('fbToken', action.payload.token)
      localStorage.setItem('user', action.payload.user.id)

      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.user,
        token: action.payload.token,
      }
    case 'SET_USER':
      return {
        ...state,
        user: action.payload.user,
      }
    case 'RESTORE_LOGIN':
      const token = localStorage.getItem('fbToken')
      const user = localStorage.getItem('user')

      return {
        ...state,
        user: { id: user } as IUser,
        isAuthenticated: token && user ? true : false,
        token: token ? token : null,
      }
    case 'LOGOUT':
      localStorage.clear()
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        token: null,
      }
    case 'LOADING':
      return {
        ...state,
        loading: action.payload.loading,
      }
    case 'LOAD_STRIPE':
      return {
        ...state,
        stripe: action.payload.stripe,
      }
    default:
      return state
  }
}
